export default __webpack_public_path__ + "static/media/signUpIllustration.3f56cf60.png";